import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'wsb-app-no-rows-overlay',
  template: `
    <div class="ag-overlay-loading-center ag-overlay-norows">
      <div *ngIf="params.filtersApplied()">
        <img src="/assets/images/icons/grid/icon-no-results.svg" />
        <h2 translate>tables_noresults</h2>
        <h3 class="mb-4" translate>tables_noresultstrychangingfilter</h3>
        <wsb-atlas-button class="mb-2 mt-4 mb-5" [variant]="'tertiary'" [label]="'common_reset'" (click)="params.clearAllFilters()">
          {{ 'common_reset' | translate }}
        </wsb-atlas-button>
      </div>
      <div *ngIf="!params.filtersApplied()">
        <img
          *ngIf="!params.options().hideImage"
          [src]="params.options().image ? params.options().image : '/assets/images/icons/grid/icon-no-results.svg'"
        />
        <h2 translate>{{ params.options().title ? params.options().title : 'tables_noresults' }}</h2>
        <h3 class="mb-5" [innerHTML]="params.options().message ? params.options().message : ('tables_noresultstext' | translate)"></h3>
        <wsb-atlas-button
          *ngIf="params.options().button"
          class="mb-2 mt-4 mb-5"
          [variant]="'tertiary'"
          [label]="params.options().button.label"
          (click)="params.options().button.click()"
        >
          {{ params.options().button.label | translate }}
        </wsb-atlas-button>
      </div>
    </div>
  `,
  standalone: false
})
export class CustomNoRowsOverlayComponent implements INoRowsOverlayAngularComp {
  params: any;

  agInit(params): void {
    this.params = params;
  }
}
